// extracted by mini-css-extract-plugin
export var redoItem = "_gs-1";
export var redoTrigger = "_gs-0";